import { BillingProductNameEnum } from "../../enum/billing/billing-product.enum";

export const EXTERNAL_ID_MAP_SOURCES: string[] = [
  BillingProductNameEnum.Synergy
];
